import Team1 from 'assets/Home/team/team1.avif'
import Team2 from 'assets/Home/team/team2.avif'
import Team3 from 'assets/Home/team/team3.avif'

import Team1Mo from 'assets/Home/team/team1Mo.avif'
import Team2Mo from 'assets/Home/team/team2Mo.avif'
import Team3Mo from 'assets/Home/team/team3Mo.avif'

interface TeamData {
    id: number
    team: string,
    teamEn: string,
    img: string,
    imgMo: string,
    intro: Intro[]
}

interface Intro {
    title: string,
    content: string
}


export const teamData: TeamData[] = [
    {
        id: 0,
        team: 'TINS LAB 기획팀',
        teamEn: 'TINS LAB Planning Team',
        img: Team1,
        imgMo: Team1Mo,
        intro: [
            { title: '요구사항 분석', content: '고객의 비즈니스 목표와 요구사항을 이해하고, 프로젝트의 방향성을 설정합니다.' },
            { title: '프로젝트 일정관리', content: '프로젝트의 전체 일정과 마일스톤을 설정하고, 각 팀에 제때작업을 완료할 수 있도록 조율합니다.' },
            { title: '기능 정의 및 스토리보드', content: '서비스의 주요 기능과 정책을 정의하고, 기획문서(요구사항 정의서, 플로우 차트, 화면 설계서 등)을 작성하여 각팀에 전달하고 리뷰합니다.' },
            { title: '커뮤니케이션', content: '고객 및 내부 팀과의 원활한 소통을 통해 진행 사항을 공유하고, 요구사항 변경 시 이를 조율하여 반영합니다.' },
        ]
    },
    {
        id: 1,
        team: 'TINS LAB 디자인팀',
        teamEn: 'TINS LAB Design Team',
        img: Team2,
        imgMo: Team2Mo,
        intro: [
            { title: '요구사항 분석', content: '비즈니스와 브랜드 아이덴티티를 정의하고, 고객의 피드백을 반영한 디자인 톤앤매너를 작성합니다.' },
            { title: 'UI / UX 설계', content: '사용자 경험을 고려한 UX전략을 수립하고, 이를 바탕으로 직관적이고 시각적으로 뛰어난 UI 디자인을 제작합니다.' },
            { title: '와이어프레임 & 프로토타입', content: '기획 된 기능을 시각적으로 표현하기 위해 와이어프레임 제작 및 고객이 시뮬레이션 할 수 있도록 프로토 타입 디자인을 제작합니다.' },
            { title: '고객 피드백 반영', content: '최종 디자인 산출물을 통해 고객의 피드백을 바탕으로 디자인을 개선하고 최적화합니다.' },
        ]
    },
    {
        id: 2,
        team: 'TINS LAB 개발팀',
        teamEn: 'TINS LAB Development Team',
        img: Team3,
        imgMo: Team3Mo,
        intro: [
            { title: '개발 환경 설정', content: '개발과 서비스 버전의 개발 환경을 구축하고 데이터 베이스의 구조를 정의하고 설계합니다.' },
            { title: '프론트, 백엔드 개발', content: '디자인을 웹페이지나 애플리케이션으로 구현하며, 서버, 데이터베이스, API 연동 등 기능로직을 처리하는 백엔드 개발을 진행합니다.' },
            { title: '테스트 및 디버깅', content: '개발 완료 후 발생할 수 있는 단위 오류를 찾아 수정하고, 서비스가 안정적으로 운영될 수 있도록 테스트 과정을 거칩니다.' },
            { title: '배포 및 유지보수', content: '개발 완료 된 프로젝트를 릴리즈 서버에 배포하고, 서비스의 전반적인 개발 운영과 지속적인 업데이트를 진행합니다.' },
        ]
    },
]